export default "__VITE_ASSET__621c1531__"